/**
 * Rendered width of the collapsed nav (siderail / icon strip), in rem. Shared because the nav
 * renders it and the layout sizes its grid tracks against it — neither module can own it.
 */
export const SIDERAIL_WIDTH_REM = 4;
